const GX_CONTACT_EMAIL = "gx_contact@goinc.jp";

/**
 * 事故報告責任者（事業者向け）の表示文言。
 * 変更・再有効化・社内メモ・変更履歴・同一人物関係はGO社内向け画面（halifax）の機能のため、
 * 本ファイルには文言を持たない。
 */
export const AccidentReportPersonsConstants = {
  ListTitle: "事故報告責任者",
  DetailTitle: "事故報告責任者詳細",
  CreateTitle: "事故報告責任者新規登録",

  // 画面上部の「この画面について」
  // これまで入力フォームで回収していた責任者情報を、この画面での登録に置き換えるため、
  // フォームの案内文（役割責任の参照先・複数名登録・別メールアドレス）をここに引き継いでいる。
  GuideTitle: "本画面について（使い方・登録時の注意事項）",
  GuideToggleHint: "（クリックで詳細の表示・非表示）",
  GuidePurpose:
    "グリーンイノベーション（GI）基金「EVタクシープロジェクト」における、稼働管理・事故報告責任者の登録・確認・削除を行う画面です。",
  GuideReference:
    "本プロジェクトでは、助成要件に基づく適切な運行データの取得および事故発生時の迅速な報告体制を構築するため、" +
    "各営業所における責任者様のご登録をお願いしております。\n" +
    "責任者様の役割や対応事項の詳細は、ダッシュボード掲載の資料『GI基金：推進体制の抜本的改善に伴うご対応依頼（参画事業者様説明用）』をご確認ください。",
  GuidePartnerStepsTitle: "主な機能・操作",
  GuidePartnerSteps: [
    {
      label: "新規登録：",
      subItems: [
        "営業所ごとに責任者を登録してください（完了後、ご登録のメールアドレスにeラーニング案内メールが届きます）。",
        "担当責任者様の不在時にも迅速にご対応・連携頂けるよう、【原則2名以上】のご登録をお願いしております（同じメールアドレスで複数名の登録も可能です）。",
      ],
    },
    {
      label: "詳細確認：",
      text: "登録内容やeラーニングの受講状況を確認できます。",
    },
    {
      label: "変更・交代：",
      text: "担当者変更の際は、旧担当者を「削除」した上で新担当者を「新規登録」してください。",
    },
  ],
  GuideCautionTitle: "ご注意事項",
  GuideCautions: [
    {
      label: "登録人数：",
      // 上限を超える登録も塞がず、問い合わせ経由でGO側が登録する運用を案内する
      text: "1営業所につき【原則2名以上・最大4名まで】です。（※1名のみ、または5名以上で登録する場合はご相談ください）。",
    },
    {
      label: "氏名・アドレスの変更：",
      text: "受講履歴を引き継ぐため、削除せず事務局へご連絡ください。",
    },
    {
      label: "データの取り扱い：",
      text: "削除データの復元は対応にお時間をいただく場合や、一部復元できない項目がございます。",
    },
  ],
  GuideContactTitle: "【お問い合わせ先】",
  GuideContactEmail: GX_CONTACT_EMAIL,

  // 登録中の責任者が0〜1名の営業所がある場合に表示する登録促進バナー。
  // 事故報告責任者一覧画面・事故報告一覧画面の両方に同一内容を表示する。
  RegistrationPromptTitle: "＜責任者の複数登録（2名以上）のお願い＞",
  RegistrationPromptBody:
    "担当者の不在・急病等による報告遅延を防ぐため、責任者の2名以上の登録を推奨しています。",
  RegistrationPromptOfficesLabel: "＜対象の営業所＞",
  RegistrationPromptOfficeFormat: (officeName: string, count: number): string =>
    `${officeName}（${count}名）`,

  // 国交省フロー組込み責任者セクション（事故報告責任者一覧とは別枠）。
  // 独立したテーブルで保持し、事業者が行える操作は登録・削除のみ（変更はGO社内へ依頼する）。
  MlitSectionTitle: "国交省フロー組込み責任者",
  MlitSectionNotes: [
    `※事故報告責任者と別の方を組み込み責任者として登録・変更する場合は、事務局（${GX_CONTACT_EMAIL}）までご連絡ください。`,
    "※国交省フロー組み込み責任者の役割が不明な場合は、ダッシュボードの資料『GI基金：推進体制の抜本的改善に伴うご対応依頼（参画事業者様説明用）』のp9をご確認ください。",
  ],
  MlitSectionEmpty: "登録されている国交省フロー組込み責任者がいません",
  TableMlitOfficeHeader: "営業所名",
  TableMlitNameHeader: "氏名",
  TableMlitEmailHeader: "メールアドレス",
  TableMlitPhoneHeader: "電話番号",
  MlitCreateButton: "登録",
  MlitCreateDialogTitle: "国交省フロー組込み責任者の登録",
  MlitCreateDialogDescription:
    "氏名・メールアドレス・電話番号を登録します。事故報告責任者と同じ方の場合も、あらためてご入力ください（事故報告責任者の登録とは連動しません）。",
  MlitCreateSuccess: "国交省フロー組込み責任者を登録しました",
  MlitDeleteDialogTitle: "国交省フロー組込み責任者の削除",
  MlitDeleteConfirmMessageFormat: (
    office: string,
    name: string,
  ): { question: string; note: string; contact: string } => ({
    question: `${office}の「${name}」を削除しますか？`,
    note: "削除すると登録情報が消去され、元に戻せません。\n※氏名やメールアドレスの変更のみの場合は削除せず、お問い合わせください。",
    contact: `【お問い合わせ】${GX_CONTACT_EMAIL}`,
  }),
  MlitNameLabel: "氏名（必須）",
  MlitEmailLabel: "メールアドレス（必須）",
  MlitPhoneLabel: "電話番号（必須）",
  MlitOfficeLabel: "会社／営業所",
  MlitDeleteSuccess: "国交省フロー組込み責任者を削除しました",

  // 検索
  OfficeName: "会社／営業所",
  NameSearchLabel: "氏名（部分一致）",
  OfficeRequiredMessage: "会社／営業所を選択してください。",

  // 一覧
  FetchError: "処理に失敗しました",
  FetchMlitError: "国交省フロー組込み責任者の取得に失敗しました",
  TableNameHeader: "氏名",
  TableEmailHeader: "メールアドレス",
  TablePhoneHeader: "電話番号",
  TableOfficeHeader: "会社／営業所",
  TableStatusHeader: "状態",
  TableLearningStatusColumnHeader: "受講状況",
  // 「有効／無効」「在任／退任」は事業者に伝わりにくいため、登録中／削除済みで表現する
  StatusActive: "登録中",
  StatusRetired: "削除済み",
  HideRetiredLabel: "登録中の責任者のみ表示",

  // 詳細
  BasicInformation: "基本情報",
  Name: "氏名",
  Email: "メールアドレス",
  Phone: "電話番号",
  PrimaryOffice: "会社／営業所",
  Status: "状態",
  Identifier: "管理者番号",
  NotFoundMessage: "事故報告責任者が見つかりません",
  RetireButton: "削除",
  RetireDialogTitle: "事故報告責任者の削除",
  RetiredMessage: "この責任者は削除済みです。元に戻すことはできません。",
  RetireConfirmMessageFormat: (
    name: string,
  ): { question: string; note: string; contact: string } => ({
    question: `「${name}」を削除しますか？`,
    note: "※氏名やメールアドレスの変更は削除せず、お問い合わせください（削除すると受講履歴が消失します）。",
    contact: `【お問い合わせ】${GX_CONTACT_EMAIL}`,
  }),

  // 受講状況
  LearningStatusTitle: "受講状況",
  LearningStatusEmpty: "受講割り当てがありません",
  TableProgramHeader: "研修プログラム",
  TableLearningStatusHeader: "状態",
  TableDeadlineHeader: "受講期限",
  TablePassedAtHeader: "合格日時",
  LearningStatusPassed: "合格",
  LearningStatusNotTaken: "未受講",
  LearningStatusOverdue: "期限超過",
  LearningStatusNotApplicable: "対象外",

  // 登録フォーム
  NameLabel: "氏名（必須）",
  EmailLabel: "メールアドレス（必須）",
  PhoneLabel: "電話番号（必須）",
  OfficeLabel: "会社／営業所（必須）",
  NameRequiredError: "氏名を入力してください。",
  NameFormatError: "氏名は100文字以内で入力してください。",
  EmailRequiredError: "メールアドレスを入力してください。",
  EmailFormatError: "有効なメールアドレスを入力してください。",
  PhoneRequiredError: "電話番号を入力してください。",
  PhoneFormatError:
    "電話番号の形式が正しくありません（先頭・末尾・連続したハイフンは使用できません）。",
  OfficeRequiredError: "会社／営業所を選択してください。",
  MlitSimultaneousRegisterLabel: "国交省フロー組込み責任者としても登録する",
  MlitSimultaneousRegisterCaption:
    "※国交省への即時報告が必要となった際に、NEDO／GOへの報告も行う責任者です（詳細：ダッシュボード掲載資料『GI基金：推進体制の抜本的改善に伴うご対応依頼』p.9）。",

  // 登録できない場合の案内（ポップアップ）。
  // 上限に達しているかの判定はサーバ側で行い、表示する文言は画面側で持つ。
  // 氏名重複など、登録実行時にサーバが返すエラーはそのメッセージをそのまま表示する。
  CannotRegisterTitle: "登録できません",
  RegistrationLimitMessage: `この営業所の事故報告責任者は、登録上限に達しています。
新たに登録する場合は、不要となった責任者を削除してから登録してください。
上限を超えて登録が必要な場合は、以下までお問い合わせください。

【お問い合わせ先】
Email：${GX_CONTACT_EMAIL}`,

  RegisterSuccess: "責任者を登録しました",
  RetireSuccess: "責任者を削除しました",
} as const;
